import React, { useState } from 'react';
import './App.css';
import FormattedInsight from './FormattedInsight.js';
import StructuredData from './StructuredData';

function App() {
    const [inputWords, setInputWords] = useState(''); // To store text from the input box
  const [isLoading, setIsLoading] = useState(false); // To know when we are waiting for the API
  const [aiInsight, setAiInsight] = useState(''); // To store the result from our API
  const [structuredData, setStructuredData] = useState(null);
  const handleExplore = async () => {
    // 1. Start loading and clear old results
    setIsLoading(true);
    setAiInsight('');

    // 2. Prepare the data to send
    // We split the input string by commas and trim any extra whitespace
    const wordsArray = inputWords.split(',').map(word => word.trim());

    try {
      // 3. Call our back-end API
      const response = await fetch('http://localhost:3001/api/explore', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ words: wordsArray }),
      });

      const data = await response.json();

      if (response.ok) {
        // 4. If successful, update our state with the AI insight
        setAiInsight(data.aiInsight);
        setStructuredData(data.structuredData);
      } else {
        // If the server sent an error, display it
        setAiInsight(`Error: ${data.error}`);
      }
    } catch (error) {
      // If there was a network error, display that
      setAiInsight('Error: Could not connect to the server.');
      console.error('Fetch error:', error);
    } finally {
      // 5. Stop loading, whether it succeeded or failed
      setIsLoading(false);
    }
  };
  return (
    // ... rest of the code
     <div className="App">
      <header className="App-header">
        <h1>Word Mapper</h1>
        <p>Enhanced Semantic Explorer</p>
      </header>
      <main className="App-main">
        {<main className="App-main">
        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Enter words separated by commas (e.g., light, knowledge)"
            value={inputWords}
            onChange={(e) => setInputWords(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleExplore();
              }
            }}
          />
          <button className="explore-button">
            <button className="explore-button" onClick={handleExplore} disabled={isLoading}>
            Explore
          </button>
          </button>
        </div>

        <div className="results-container">
          {<div className="results-container">
      {isLoading && <p>Thinking...</p>}
      {/* --- ADD THE NEW COMPONENT HERE --- */}
      {structuredData && <StructuredData data={structuredData} />}
      {aiInsight && <FormattedInsight text={aiInsight} />}
    </div>}
        </div>
      </main>}
      </main>
    </div>
  );
}

export default App;